import axios from "axios";
import qs from "qs/dist/qs";
import Config from "../js/config";

function IWAjax(params) {
    const config = new Config();
    if(!params.data) params.data = [];

    const app = params.app;
    params.data.username = localStorage.getItem("username");
    if(typeof params.showPreloader === "undefined") params.showPreloader = true;
    const ws = function(){
        if(params.showPreloader) app.preloader.show();
        return axios({
            method: 'POST',
            headers: {'Authorization': localStorage.getItem("token_type") + " " + localStorage.getItem("access_token")},
            data: qs.stringify(params.data),
            url: config.api_url + params.route
        }).then(function (res){
            if(params.showPreloader) app.preloader.hide();
            if(!res.data) {
                app.dialog.alert("Errore di comunicazione con il server", "IrideWeb", function(){ console.log(res); });
                return false;
            }
            if(res.data.error === "Invalid Username"){
                localStorage.clear();
                app.dialog.alert("Utente loggato non valido. Effettuare l'accesso al sistema", "IrideWeb", function(){ app.router.navigate("/login/")});
                return false;
            }
            if(typeof params.success === "function")
                params.success(typeof res.data === "undefined" ? {error: "Errore di comunicazione con il server"} : res.data);

            return true;
        });
    };

    if(!localStorage.getItem("access_token"))
        getToken(ws, app, params);
    else {
        ws().catch(function (error) {
            getToken(ws, app, params);
            if(params.showPreloader) app.preloader.hide();
        });
    }
}

function getToken(ws, app, params){
    const config = new Config();

    axios({
        method: 'POST',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify({
            client_id: config.codicecliente,
            grant_type: "client_credentials",
            client_secret: config.client_secret
        }),
        url: config.iride_url + "/api/webapps/token"
    }).then(res => res.data.data).then(function(res) {
        localStorage.setItem("token_type", res.token_type);
        localStorage.setItem("access_token", res.access_token);

        if(typeof ws === "function") ws();
    }).catch(function (error){
        localStorage.clear();
        app.views.main.router.navigate("/login/");
        if(params.showPreloader) app.preloader.hide();
    });
}

export default IWAjax